import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import '@/assets/style/index.css'
import 'element-ui/lib/theme-chalk/index.css';
import store from './store/index'
import '@/utils/global'//全局
import '@/icons' // icon
import '@/permission' // permission control
import * as filters from './utils/filters'
import {hasPermission} from './utils/permissionButton.js'//按钮权限指令
// import echarts from 'echarts'


Vue.use(hasPermission) // 按钮权限指令
Object.keys(filters).forEach(key => {
    Vue.filter(key, filters[key])
})
Vue.config.productionTip = false
Vue.use(ElementUI)
// Vue.prototype.$echarts = echarts
// 全局路由守卫

/* eslint-disable no-new */
new Vue({
    el: '#app',
    router,
    store,
    components: {App},
    template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js